import generalFilter from 'services/Home/strategies/filter-smart-alert/generalFilter'
import sellerFilter from 'services/Home/strategies/filter-smart-alert/sellerFilter'
import { ISmartAlertMarketplaceDocument } from 'services/Home/widgets/SmartAlert/interface'

function filterSmartAlert(
  alert: ISmartAlertMarketplaceDocument,
  page: string,
): boolean {
  const targetMapper = {
    seller: sellerFilter(alert, page),
    buyer: false,
    general: generalFilter(alert, page),
  }
  return targetMapper[alert.configuration.target || 'general']
}

export default filterSmartAlert
